import React, { Dispatch, FC, SetStateAction } from 'react';
import { QuestionnaireForm } from './QuestionnaireForm';
import { QuestionnaireFormBuilder, QuestionnaireFormBuilderProps } from '../QuestionnaireFormBuilder';
import { FlexboxVertical } from '../../Layout';
import { Headline4, TextDefault } from '../../Text';
import styled from 'styled-components';
import { Colors } from '../../../../styles/colors';
import { NoteItem } from '../notes-popup/NoteItem';
import { useRecoilState } from 'recoil';
import { NotesPopupState, NotesState } from '../../../../state/NotesState';
import { Note } from '../../../../interfaces/Operation';
import { QuestionnaireWithResultSets } from '../../../../interfaces/Questionnaire';
import { TextBox } from '../../forms/TextBox';
import { useShowConfirmationPopup } from '../../ConfirmationPopup';

interface Props extends Omit<QuestionnaireFormBuilderProps, 'questionnaireId' | 'questions'> {
  questionnaire: QuestionnaireWithResultSets;
}
export const QuestionnaireConcludingQuestions: FC<Props> = ({ questionnaire, ...props }) => {
  return (
    <QuestionnaireForm title={'Beratung abschließen'}>

      <QuestionnaireFormBuilder
        {...props}
        questionnaireId={questionnaire.id}
        questions={questionnaire.questionnaire.questions}
      />

    </QuestionnaireForm>
  )
}

const ConcludingNotesWrapper = styled(FlexboxVertical)`
  margin-top: 3rem;

  ${Headline4} {
    margin-bottom: 1.5rem;
  }
`;
const ConcludingNotesFormWrapper = styled(FlexboxVertical)`
  background: ${Colors.white};
  padding: 1.5rem;
`;
const NoteInputWrapper = styled(ConcludingNotesFormWrapper)`
  min-height: 15rem;
  
  & > * {
    padding-top: 0;
    
    div {
      padding: 0;
      
      textarea {
        padding: 0;
        border: none;
        background: transparent;
      }
    }
  }
`;

export const ConcludingNotes: FC<{ textState: [string, Dispatch<SetStateAction<string>>] }> = ({ textState, ...props }) => {
  const [text, setText] = textState;
  return (
    <ConcludingNotesWrapper>
      <Headline4>Zusätzliche Anmerkungen</Headline4>
      <NoteInputWrapper>
        <TextBox
          id={'concluding-note-input-body'}
          placeholder={'Hier eingeben'}
          onChange={(e) => setText(e.target.value)}
          value={text}
        />
      </NoteInputWrapper>
    </ConcludingNotesWrapper>
  )
}

export const NotesSummary: FC = ({ ...props }) => {
  const showConfirmationPopup = useShowConfirmationPopup();
  const [notes, setNotes] = useRecoilState(NotesState);
  const [notesPopupState, setNotesPopupState] = useRecoilState(NotesPopupState);
  const setEditNote = (editNode: Note) => {
    setNotesPopupState({
      open: true,
      editNode,
    });
  }

  return (
    <ConcludingNotesWrapper>
      <Headline4>Bereits vorhandene Notizen</Headline4>
      <ConcludingNotesFormWrapper>
        {
          notes.list?.length > 0 && notes.list.map((note) => (
            <NoteItem
              title={note.subject}
              onEditClick={() => setEditNote(note)}
              onDeleteClick={() => {
                showConfirmationPopup({
                  open: true,
                  actionButtonLabel: 'Löschen',
                  closeFn() {
                    showConfirmationPopup(null);
                  },
                  actionFn() {
                    showConfirmationPopup(null);    // close popup
                    setNotes({ list: notes.list.filter(({ timestamp }) => timestamp !== note.timestamp) });
                  },
                  renderer() {
                    return <>Wollen Sie die Notiz zu "{ note.subject }" wirklich löschen?</>;
                  },
                });
              }}
            />
          )) || <TextDefault>keine</TextDefault>
        }
      </ConcludingNotesFormWrapper>
    </ConcludingNotesWrapper>
  )
}
